export interface FooterLink {
  label: string
  href: string
}

export const maintenance = {
  title: 'Scheduled maintenance',
  summary:
    'The Talent Portal is offline for planned maintenance. Nothing has been lost and no action is needed on your side — everything will be waiting for you when we return.',
  /** Fixed, absolute end of the window — 12:30 AM UTC (estimated). */
  endsAtIso: '2026-08-14T00:30:00Z',
  supportEmail: 'support@turing.com',
  address: '548 Market Street, San Francisco, California',
  copyright: '© 2026 Turing Enterprises, Inc.'
}

export type SocialIcon = 'youtube' | 'x' | 'linkedin' | 'instagram'

export interface SocialLink {
  label: string
  href: string
  icon: SocialIcon
}

export const socialLinks: SocialLink[] = [
  { label: 'Turing on YouTube', href: 'https://www.youtube.com/@Turingcom', icon: 'youtube' },
  { label: 'Turing on X', href: 'https://x.com/turingcom', icon: 'x' },
  {
    label: 'Turing on LinkedIn',
    href: 'https://www.linkedin.com/company/turingcom',
    icon: 'linkedin'
  },
  {
    label: 'Turing on Instagram',
    href: 'https://www.instagram.com/turingcom/',
    icon: 'instagram'
  }
]

export const footerLinks: FooterLink[] = [
  { label: 'About Turing', href: 'https://www.turing.com/company' },
  { label: 'Support', href: 'https://help.turing.com/' },
  { label: 'Terms of Service', href: 'https://www.turing.com/terms-of-service' },
  { label: 'Privacy Policy', href: 'https://www.turing.com/policy' }
]
